export const apiBaseUrl = `https://backend.workerfit.com/api/v1`;
export const frontEndApiBaseUrl = `https://examfit.workerfit.com`;
